import {FC, useState} from 'react'
import useModals from '../../../hooks/useModals'
import {i18n} from '../../../translate/i18n'
import styles from './modalImageCrop.module.css'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'

type Props = {
  imageCrop: any
  setCropper: (value: any) => void
  getCropData: () => void
  onUseOriginalImage?: () => void
  onUseSelectedSize?: (width: number, height: number) => void
}

const ModalImagemCropped: FC<Props> = ({
  imageCrop,
  setCropper,
  getCropData,
  onUseOriginalImage,
  onUseSelectedSize,
}) => {
  const {imageCroppedModal, closeImageCropped} = useModals()
  const [selectedFormat, setSelectedFormat] = useState<string>('640x640')

  const cropImage = () => {
    getCropData()
    closeImageCropped()
  }

  const useOriginal = () => {
    if (onUseOriginalImage) {
      onUseOriginalImage()
    }
    closeImageCropped()
  }

  const useSelectedSize = () => {
    if (onUseSelectedSize) {
      // Extrair width e height do formato selecionado
      const [width, height] = selectedFormat.split('x').map(Number)
      onUseSelectedSize(width, height)
    }
    closeImageCropped()
  }

  return (
    <>
      {imageCroppedModal.display && (
        <>
          <div onClick={() => closeImageCropped()} className={styles.background}></div>
          <div
            className={`${styles.modalCustom} modal-dialog`}
            style={{width: '70%', maxWidth: '800px'}}
          >
            <div
              className={`${styles.modalContent} modal-content`}
              style={{maxHeight: '90vh', display: 'flex', flexDirection: 'column'}}
            >
              <div className='modal-header'>
                <h5 className='modal-title'>{i18n.t(`smart_order.crop_image`)}</h5>
                <div
                  className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                  onClick={() => closeImageCropped()}
                >
                  <i className='fa fa-times' aria-hidden='true'></i>
                </div>
              </div>
              <div
                className='modal-body text-break pt-4 d-flex justify-content-center flex-grow-1 overflow-auto'
                style={{minHeight: '300px'}}
              >
                <div className='w-100 d-flex flex-column align-items-center'>
                  <div className='mb-3'>
                    <Cropper
                      src={imageCrop ? imageCrop : ''}
                      style={{height: '300px', width: '400px', maxWidth: '100%'}}
                      initialAspectRatio={4 / 3}
                      minCropBoxHeight={100}
                      minCropBoxWidth={100}
                      guides={false}
                      checkOrientation={false}
                      onInitialized={(instance: any) => {
                        setCropper(instance)
                      }}
                    />
                  </div>

                  {/* Seleção de formato */}
                  {onUseSelectedSize && (
                    <div className='mb-3'>
                      <h6 className='text-center mb-2'>
                        {i18n.t(`smart_order.select_image_format`)}
                      </h6>
                      <div className='d-flex justify-content-center gap-3'>
                        <label className='d-flex align-items-center'>
                          <input
                            type='radio'
                            name='imageFormat'
                            value='640x640'
                            checked={selectedFormat === '640x640'}
                            onChange={(e) => setSelectedFormat(e.target.value)}
                            className='me-2'
                          />
                          {i18n.t(`smart_order.format_640x640`)}
                        </label>
                        <label className='d-flex align-items-center'>
                          <input
                            type='radio'
                            name='imageFormat'
                            value='600x900'
                            checked={selectedFormat === '600x900'}
                            onChange={(e) => setSelectedFormat(e.target.value)}
                            className='me-2'
                          />
                          {i18n.t(`smart_order.format_600x900`)}
                        </label>
                      </div>
                    </div>
                  )}

                  {/* Mensagem explicativa sobre o recorte */}
                  <div className='mb-3 text-center'>
                    <small className='text-muted fst-italic'>
                      <strong>Dica:</strong> Use "Recortar imagem" apenas quando desejar dar ênfase
                      a uma parte específica da imagem, destacando melhor a área recortada.
                    </small>
                  </div>

                  <div className='d-flex justify-content-center flex-wrap gap-2'>
                    {onUseOriginalImage && (
                      <button className='btn btn-secondary px-3 py-2' onClick={useOriginal}>
                        {i18n.t(`smart_order.use_original_image`)}
                      </button>
                    )}
                    {onUseSelectedSize && (
                      <button className='btn btn-primary px-3 py-2' onClick={useSelectedSize}>
                        {i18n.t(`smart_order.use_selected_size`)}
                      </button>
                    )}
                    <button className='btn btn-dark px-3 py-2' onClick={cropImage}>
                      {i18n.t(`smart_order.crop_image`)}
                    </button>
                  </div>
                </div>
              </div>
              <div className='modal-footer d-flex justify-content-end border-top pt-3'>
                <button
                  type='button'
                  className='btn btn-light px-4'
                  onClick={() => closeImageCropped()}
                >
                  {i18n.t(`buttons.close`)}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export {ModalImagemCropped}
